export const ContentPageId = 'Contentpage';
